// extracted by mini-css-extract-plugin
export default {"root":"SmallScreenPanel4_root_N3X79"};